import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import DatesList from './DatesList/DatesList';
import SolutionMatrixDialog from './SolutionMatrixDialog/SolutionMatrixDialog';
import Container from './styles/Container';
import { usePatchLogisticTaskMutation } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';

function SolutionsInfoSection({ logisticTaskId, source, stateData }) {
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const [patchLogisticTask] = usePatchLogisticTaskMutation();

  const dateMatrixes = Object.entries(stateData?.stateMap?.transportTaskResult ?? {})
    .map(([dateStr, value]) => {
      const factData = source?.fieldsFactVolumes?.[dateStr];
      return {
        date: parseISO(dateStr),
        planMatrix: value.matrix,
        planTotalFromFields: value.avgExportFromField,
        planTotalFromElevators: value.avgExportOnConsumer,
        factMatrix: factData?.exportVolume,
        factTotalFromFields: factData?.avgExportFromField,
        factTotalFromElevators: factData?.avgExportOnConsumer,
        totalProduct: {
          fact: Object.values(factData?.avgExportOnConsumer ?? {}).reduce((acc, val) => acc + val, 0),
          plan: value.matrix?.reduce((sum, item) => sum + item.volume, 0),
        },
      };
    })
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  const fields = source?.fieldDetailsList?.map((field) => ({ id: field?.geozoneId, name: field?.fieldName }));
  const elevators = source?.warehouseDetailsList?.map((warehouse) => ({
    id: warehouse?.geozoneUnloadId,
    name: warehouse?.name,
  }));

  const handleUpdateFactVolumes = (date, newData) => {
    const dateStr = format(date, 'yyyy-MM-dd');
    const updatedField = { ...source.fieldsFactVolumes };

    patchLogisticTask({
      id: logisticTaskId,
      body: {
        logisticTaskId,
        source: {
          fieldsFactVolumes: { ...updatedField, [dateStr]: { ...updatedField[dateStr], ...newData } },
        },
      },
    });
  };

  const handleDateClick = (data) => {
    setSelectedData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedData({});
  };

  return (
    <Container>
      <DatesList data={dateMatrixes} onDateClick={handleDateClick} />
      <SolutionMatrixDialog
        open={open}
        onClose={handleClose}
        fields={fields}
        elevators={elevators}
        solutionData={selectedData}
        onChangeFactVolumes={handleUpdateFactVolumes}
      />
    </Container>
  );
}

SolutionsInfoSection.propTypes = {
  source: PropTypes.shape().isRequired,
  stateData: PropTypes.shape().isRequired,
  logisticTaskId: PropTypes.number.isRequired,
};

export default SolutionsInfoSection;
